import { render, staticRenderFns } from "./ChipCell.vue?vue&type=template&id=3669c009&scoped=true&"
import script from "./ChipCell.vue?vue&type=script&lang=js&"
export * from "./ChipCell.vue?vue&type=script&lang=js&"
import style0 from "./ChipCell.vue?vue&type=style&index=0&id=3669c009&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3669c009",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
